import { DEFAULT_DATA, setSliceGuideModalsData, setSliceGuideModalsInfo } from '../slices/FJSliceGuideModals';

const FJActionGuide = {
    /**
     * @param {Object} data - The data to be set in the guide modal.
     * @returns {Function} - A function that dispatches the setSliceGuideModalsInfo and setSliceGuideModalsData actions.
     */
    showGuideModalAction: data => {
        return dispatch => {
            dispatch(setSliceGuideModalsInfo(true));
            dispatch(
                setSliceGuideModalsData({
                    ...DEFAULT_DATA,
                    ...data,
                }),
            );
        };
    },

    hideGuideModalAction: () => {
        return dispatch => {
            dispatch(setSliceGuideModalsInfo(false));
            dispatch(setSliceGuideModalsData(DEFAULT_DATA));
        };
    },
};

export default FJActionGuide;
